import { getCheckboxValue, roundReimbPsf } from '../../reimbTypesPersistence';

let cloneDeep = require('lodash.clonedeep');

export const reimbursementTypes = {
    headerRow: ['Code', 'Description', 'Admin Fee %', '', 'CAM', '', 'Management Fee', '', 'Insurance', '', 'Real Estate Taxes'],
    rows: {},
};

export function buildReimbursementTypes(typesDataRow, index, tab) {
    return cloneDeep({
        valueCells: [{      // 0 - Code
            editable: false,
            getComputedValue() {
                return {internalValue: index + 1, displayValue: index + 1};
            }
        }, {                // 1 - Description
            editable: true,
            placeholder: 'Insert Description',
            value: tab === 'current-reimbursement-tab' ? typesDataRow.REIMB_TYPES_DESCRIPTION
                : tab === 'proforma-reimbursement-tab' && typesDataRow.PRO_FORMA_REIMB_TYPES_DESCRIPTION,
        }, {                // 2 - Admin Fee %
            editable: true,
            type: 'number',
            unit: '%',
            value: tab === 'current-reimbursement-tab' && typesDataRow.REIMB_TYPES_CAM_INCREASE ? parseFloat(typesDataRow.REIMB_TYPES_CAM_INCREASE)
                : tab === 'proforma-reimbursement-tab' && typesDataRow.PRO_FORMA_REIMB_TYPES_CAM_INCREASE ? parseFloat(typesDataRow.PRO_FORMA_REIMB_TYPES_CAM_INCREASE) : '',
        }, {                // 3 - CAM Checkbox
            editable: true,
            type: 'boolean',
            value: getCheckboxValue(tab, typesDataRow, 'REIMB_TYPES_HAS_CAM'),
        }, {                // 4 - CAM
            editable: true,
            type: 'number',
            unit: '$',
            value: tab === 'current-reimbursement-tab' && typesDataRow.REIMB_TYPES_CAM_VALUE ? roundReimbPsf(typesDataRow.REIMB_TYPES_CAM_VALUE)
                : tab === 'proforma-reimbursement-tab' && typesDataRow.PRO_FORMA_REIMB_TYPES_CAM_VALUE ? roundReimbPsf(typesDataRow.PRO_FORMA_REIMB_TYPES_CAM_VALUE) : 0,
        }, {                // 5 - Management Fee Checkbox
            editable: true,
            type: 'boolean',
            value: getCheckboxValue(tab, typesDataRow, 'REIMB_TYPES_HAS_MANAGEMENT_FEE'),
        }, {                // 6 - Management Fee
            editable: true,
            type: 'number',
            unit: '$',
            value: tab === 'current-reimbursement-tab' && typesDataRow.REIMB_TYPES_MGMT_FEE_VALUE ? roundReimbPsf(typesDataRow.REIMB_TYPES_MGMT_FEE_VALUE)
                : tab === 'proforma-reimbursement-tab' && typesDataRow.PRO_FORMA_REIMB_TYPES_MGMT_FEE_VALUE ? roundReimbPsf(typesDataRow.PRO_FORMA_REIMB_TYPES_MGMT_FEE_VALUE) : 0,
        }, {                // 7 - Insurance Checkbox
            editable: true,
            type: 'boolean',
            value: getCheckboxValue(tab, typesDataRow, 'REIMB_TYPES_HAS_INSURANCE'),
        }, {                // 8 - Insurance
            editable: true,
            type: 'number',
            unit: '$',
            value: tab === 'current-reimbursement-tab' && typesDataRow.REIMB_TYPES_INSURANCE_VALUE ? roundReimbPsf(typesDataRow.REIMB_TYPES_INSURANCE_VALUE)
                : tab === 'proforma-reimbursement-tab' && typesDataRow.PRO_FORMA_REIMB_TYPES_INSURANCE_VALUE ? roundReimbPsf(typesDataRow.PRO_FORMA_REIMB_TYPES_INSURANCE_VALUE) : 0,
        }, {                // 9 - Real Estate Taxes Checkbox
            editable: true,
            type: 'boolean',
            value: getCheckboxValue(tab, typesDataRow, 'REIMB_TYPES_HAS_TAXES'),
        }, {                // 10 - Real Estate Taxes
            editable: true,
            type: 'number',
            unit: '$',
            value: tab === 'current-reimbursement-tab' && typesDataRow.REIMB_TYPES_TAXES_VALUE ? roundReimbPsf(typesDataRow.REIMB_TYPES_TAXES_VALUE)
                : tab === 'proforma-reimbursement-tab' && typesDataRow.PRO_FORMA_REIMB_TYPES_TAXES_VALUE ? roundReimbPsf(typesDataRow.PRO_FORMA_REIMB_TYPES_TAXES_VALUE) : 0,
        }]
    });
}

const expensesNameIndex = 0;
const expensesValueIndex = 2;
const expensesPfValueIndex = 5;

export const reimbursableOpEx = {
    headerRow: ['Reimbursable Expenses:', '', 'Denom:', 'Cat:', 'CAM', 'Management Fee', 'Insurance', 'Real Estate Taxes'],
    rows: {}
};

export function buildReimbursableOpEx(tab) {
    const reimbTab = tab.includes('proforma') ? 'proforma-reimbursement-tab': 'current-reimbursement-tab';
    const valueIndex = tab.includes('proforma') ? expensesPfValueIndex : expensesValueIndex;

    return cloneDeep({
        'cam-1': {
            valueCells: [{
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const expensesRowName = tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[expensesNameIndex].value;
                    return {displayValue: expensesRowName}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Sub1'}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'cam-2': {
            valueCells: [{
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const expensesRowName = tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[expensesNameIndex].value;
                    return {displayValue: expensesRowName}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Sub1'}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'cam-3': {
            valueCells: [{
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const expensesRowName = tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[expensesNameIndex].value;
                    return {displayValue: expensesRowName}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Sub1'}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'cam-4': {
            valueCells: [{
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const expensesRowName = tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[expensesNameIndex].value;
                    return {displayValue: expensesRowName}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Sub1'}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'cam-5': {
            valueCells: [{
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const expensesRowName = tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[expensesNameIndex].value;
                    return {displayValue: expensesRowName}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows[rowIdentifier].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Sub1'}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'management': {
            valueCells: [{
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Management'}
                }
            }, {
                editable: false,
                getComputedValue(tabs) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['management-fee'].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'MGT'}
                }
            }, {
                empty: true
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'non-reimbursable-expenses': {
            valueCells: [{
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Non-Reimbursable Expenses'}
                }
            }, {
                editable: false,
                getComputedValue(tabs,) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['non-reimbursable-expenses'].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            },]
        },
        'insurance': {
            valueCells: [{
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Insurance'}
                }
            }, {
                editable: false,
                getComputedValue(tabs,) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['insurance'].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'INS'}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat((reimbursableOpEx / denom));
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                empty: true
            },]
        },
        'real-estate-taxes': {
            valueCells: [{
                editable: false,
                getComputedValue() {
                    return {displayValue: 'Real Estate Taxes'}
                }
            }, {
                editable: false,
                getComputedValue(tabs) {
                    const value = parseFloat(tabs['expenses-tab'].tables['expenses'].rows['real-estate-taxes'].valueCells[valueIndex].value);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-';
                    return {internalValue: value, displayValue: displayValue}
                }
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const value = precomputedValues.totalSpace;
                    return {internalValue: value, displayValue: `${value.toLocaleString()}`}
                }
            }, {
                editable: false,
                getComputedValue() {
                    return {displayValue: 'MT'}
                }
            }, {
                empty: true
            }, {
                empty: true
            }, {
                empty: true
            }, {
                editable: false,
                getComputedValue(tabs, rowIdentifier, precomputedValues) {
                    const reimbursableOpEx = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const denom = tabs[reimbTab].tables['reimbursable-op-ex'].rows[rowIdentifier].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                    const value = parseFloat(reimbursableOpEx / denom);
                    const displayValue = value && !isNaN(value) ? `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '';
                    return {internalValue: value, displayValue: displayValue}
                }
            }]
        },
    })
}

export { getCheckboxValue };
